import { MyProjectsLayout } from "./my-projects/my-projects.layout";
import { MyProjectsPage } from "./my-projects/my-projects.page";

export const myProjectRoutes = [
  {
    path: "my-projects",
    element: <MyProjectsLayout />,
    children: [{ path: "", element: <MyProjectsPage /> }],
  },
];
